import { v4 as uuid } from "uuid";
import type { MigrationStrategies } from "./_types/migration-strategies";

export const INVOICE_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc: Record<string, unknown>) => ({
    ...oldDoc,
    finalizedAt: oldDoc.finalizedAt ?? null,
    finalizedByUserId: oldDoc.finalizedByUserId ?? null,
    priceListLastSyncedAt: oldDoc.priceListLastSyncedAt ?? null,
  }),
  2: (oldDoc: Record<string, unknown>) => oldDoc,
  3: (oldDoc: Record<string, unknown>) => ({
    ...oldDoc,
    payers: Array.isArray(oldDoc.payers)
      ? oldDoc.payers.map((payer: Record<string, unknown>) => ({
          ...payer,
          id:
            typeof payer.id === "string" &&
            payer.id.length > 0 &&
            payer.id.trim() === payer.id
              ? payer.id
              : uuid(),
        }))
      : [],
  }),
  // The schema embeds Object.values(BillingCurrency); LRD and USD changed its
  // hash, and RxDB throws DB6 on a changed schema at the same version.
  4: (oldDoc: Record<string, unknown>) => oldDoc,
};
